
import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios'
import {message} from 'antd'
import keyUri from '../../key'

export const initialState = {

    loading: false,
    hasErrors: false,
    jobs:[],
    currentjob:null,
}

export const JobSlice = createSlice({
    name:"jobs",
    initialState,
    reducers:{

        getJob: state =>{

            state.loading = true
        },

        getJobSuccess: (state, {payload}) =>{
            state.loading = false
            state.jobs = payload
            
        },

        getCurrentJob: (state, {payload}) =>{
          console.log({k:payload});

            state.loading = false
            state.currentjob = payload
            
        },
        getJobFailure: (state, {payload}) =>{

            state.loading = false
            state.jobs = payload
            
        },

    }
})

export const {getJob, getJobSuccess, getCurrentJob, getJobFailure } = JobSlice.actions
      
export const JobSelector = state => state.jobs
export default JobSlice.reducer


const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };



export const  fetchAllJob = () => async dispatch =>{
      const key = "Job"
      dispatch(getJob())
      
    try {

        const {data} = await axios.get(keyUri.BACKEND_URI +'/jobs');
        console.log(data)
        dispatch(getJobSuccess(data))

    } catch ({response}) {

        dispatch(getJobFailure())
        response.data && message.error({ content: response.data.msg, key, duration: 2 });

    }
    
}

export const  fetchOneJob = (id) => async dispatch =>{

    dispatch(getJob())
    
  try {

      const {data} = await axios.get(keyUri.BACKEND_URI +`/job/${id}`);
      dispatch(getCurrentJob(data))

  } catch ({response}) {

      dispatch(getJobFailure())
    //   response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  createJob = (values) => async dispatch =>{
  console.log(values);
    const key = "Job"
    dispatch(getJob())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.post(keyUri.BACKEND_URI +'/jobs', values, config);
      setTimeout(() => {

        message.success({ content: data.msg, key, duration: 2 });
      }, 500) 
        dispatch(fetchAllJob())

  } catch ({response}) {
       dispatch(getJobFailure())
  }
  
}


export const  deleteJob = (id) => async dispatch =>{
    const key = "Job"
    dispatch(getJob())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.delete(keyUri.BACKEND_URI +`/job/${id}`);
      data && message.success({ content: data.msg, key, duration: 2 });
      dispatch(fetchAllJob())

  } catch ({response}) {

      dispatch(getJobFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}


export const  updateJob = (id, values) => async dispatch =>{
    const key = "Job"
    dispatch(getJob())
    message.loading({ content: 'loading...', key })
    
  try {

      const {data} = await axios.put(keyUri.BACKEND_URI +`/job/${id}`, values, config);
      data && message.success({ content: data.msg, key, duration: 2 });
      window.location.reload()
      dispatch(fetchAllJob())

  } catch ({response}) {

      dispatch(getJobFailure())
      response.data && message.error({ content: response.data.msg, key, duration: 2 });

  }
  
}




